import styled, { css } from 'styled-components';

// Defaults match the blog table look (see blogConfig.table in marketConfigs).
const TABLE_DEFAULTS = {
  borderColor: '#E6E9E5',
  headerFontSize: '22px',
  headerFontSizeMobile: '16px',
  bodyFontSize: '18px',
  bodyFontSizeMobile: '14px',
  lineHeight: 1.5,
  cellPadding: '8px 12px',
};

// Structural table styles for CMS html: borders, paddings, font sizes,
// alignment and horizontal scroll on mobile. Background and text colors are
// intentionally left out so tables blend into any surrounding block; the blog
// adds its own colored header and striped rows on top of this.
// `getTableConfig` picks the table config object from the styled props.
export const htmlTableStyles = (getTableConfig) => {
  const value = (key) => (props) => getTableConfig(props)?.[key] || TABLE_DEFAULTS[key];

  return css`
    table,
    table * {
      box-sizing: border-box;
    }

    /* Some wrappers use white-space: pre-line for plain-text copy; inside
       tables it turns markup newlines into blank lines in the cells. */
    table {
      white-space: normal;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      margin: 0 0 24px;
      border: 1px solid ${value('borderColor')};
    }

    table th {
      font-size: ${value('headerFontSize')};
      font-weight: bold;
      text-align: left;
      vertical-align: middle;
      padding: ${value('cellPadding')};
      border: 1px solid ${value('borderColor')};
      line-height: ${value('lineHeight')};
    }

    table td {
      font-size: ${value('bodyFontSize')};
      font-weight: normal;
      text-align: left;
      vertical-align: middle;
      padding: ${value('cellPadding')};
      border: 1px solid ${value('borderColor')};
      line-height: ${value('lineHeight')};
    }

    table th p,
    table td p {
      margin: 0;
    }

    @media (max-width: 860px) {
      table {
        display: block;
        overflow-x: auto;
        max-width: 100%;
      }

      table th {
        font-size: ${value('headerFontSizeMobile')};
      }

      table td {
        font-size: ${value('bodyFontSizeMobile')};
      }
    }
  `;
};

// `&&` doubles the class so these rules beat the `.default_styles * { all: revert }`
// resets that parent containers apply to the same html.
export const StyledHtmlContent = styled.div`
  && {
    ${htmlTableStyles(({ $tableConfig }) => $tableConfig)}
  }
`;
